// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — control.styled.classic.js, новая — control.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './control.styled.classic';
import * as cp from './control.styled.cp';

export const Control = isCp ? cp.Control : classic.Control;
